import { Component, Input } from '@angular/core';
import { MarkerComponent, PopupComponent } from '@maplibre/ngx-maplibre-gl';
import { DatePipe, NgStyle } from '@angular/common';
import { Position } from '@wheere/api-tracker';

@Component({
  selector: 'lib-map-position-marker',
  standalone: true,
  imports: [MarkerComponent, PopupComponent, NgStyle, DatePipe],
  template: `
    <mgl-marker #markerRef [lngLat]="{ lng: position.longitude!, lat: position.latitude! }">
      <button class="relative flex size-3">
        <span class="relative inline-flex size-3 rounded-full" [ngStyle]="{ 'background-color': '#ff1111' }"> </span>
      </button>
    </mgl-marker>

    <mgl-popup [offset]="16" [marker]="markerRef" [closeButton]="false" [maxWidth]="'250'">
      <div class="mt-2 flex items-center gap-2">
        <i class="pi pi-calendar text-primary-500"></i>
        <span class="text-base">{{ position.timestamp | date: 'dd/MM/yyyy - hh:mm:ss' }}</span>
      </div>
      <div class="flex items-center gap-2">
        <i class="pi pi-map-marker text-primary-500"></i>
        <span class="text-sm">
          <span class="font-bold">Lat:</span> {{ position.latitude }}, <span class="font-bold">Lng:</span>
          {{ position.longitude }}
        </span>
      </div>
    </mgl-popup>
  `,
})
export class MapPositionMarkerComponent {
  @Input() position!: Position;
}
